<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)"
>
</app-ship-details>

<div
  class="card-nc"
  style="background-color: #ffffff; height: 40px"
  *ngIf="hasEntitlement('SHIPS_BULKCARDS_ACTIVATION')"
>
  <span class="pull-right save-panel">
    <button
      style="height: 38px"
      type="submit"
      [disabled]="activate_cardholders_btn"
      (click)="activateCardholders()"
      class="btn btn-nc"
    >
      ACTIVATE
      <i [ngClass]="save_ac_btn_spinner"></i>
    </button>
  </span>
  <div class="row" style="padding-top: 10px; margin-left: 10px">
    <span class="labelCommon">&nbsp;Bulk Cardholder Activation</span>
  </div>
</div>

<div
  class="card-nc"
  style="background-color: #ffffff; height: 40px"
  *ngIf="hasEntitlement('SHIPS_BULKCARDS_REPLACEMENT')"
>
  <span class="pull-right save-panel">
    <button
      style="height: 38px"
      type="submit"
      [disabled]="order_replacementCards_btn || isRosterSizeUndefined()"
      (click)="orderReplacementCardsByLocation()"
      class="btn btn-nc"
    >
      ORDER
      <i [ngClass]="order_repCards_btn_spinner"></i>
    </button>
  </span>
  <div class="row" style="padding-top: 10px; margin-left: 10px">
    <span class="labelCommon"
      >&nbsp;Order Replacement Cards For Entire Location</span
    >
  </div>
</div>

<div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW')">
  <div class="card-heading">
    <i class="fa fa-credit-card"></i>
    <span class="cardHeaderHeading"> Bulk Temp and Visitor Card Orders </span>
    <span
      class="pull-right save-panel"
      style="margin-top: -10px; margin-right: -15px"
    >
      <button
        *ngIf="confirmMode && hasEntitlement('SHIPS_BULKCARDS_ORDERS_UPDATE')"
        type="button"
        (click)="confirmMode = !confirmMode"
        class="btn btn-cancel"
        style="font-size: 11px; margin-right: 10px; background-color: #949494"
      >
        CANCEL
      </button>
      <button
        *ngIf="confirmMode && hasEntitlement('SHIPS_BULKCARDS_ORDERS_UPDATE')"
        type="submit"
        (click)="onOrderClick()"
        class="btn btn-nc"
      >
        CONFIRM
        <i [ngClass]="save_oc_btn_spinner"></i>
      </button>
      <button
        *ngIf="!confirmMode && hasEntitlement('SHIPS_BULKCARDS_ORDERS_UPDATE')"
        type="button"
        (click)="onConfirmClick()"
        class="btn btn-nc"
        [disabled]="!bulkVisitorCardForm.get('quantity').valid"
      >
        ORDER
      </button>
    </span>
  </div>
  <div class="card-body" *ngIf="ship">
    <form name="bulkVisitorCardForm" [formGroup]="bulkVisitorCardForm">
      <div class="row">
        <div class="col-md-4">
          <label for="bulkCardType" class="col-md-12 control-label labelCommon">
            Card Type
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              id="bulkCardType"
              formControlName="type"
              (change)="setCardType($event.target.value)"
            >
              <option
                *ngFor="
                  let cardType of cardTypeArray.getCardArray();
                  trackBy: identify
                "
                [value]="cardType.value"
              >
                {{ cardType.label }}
              </option>
            </select>
            <span
              *ngIf="
                !bulkVisitorCardForm.get('type').valid &&
                bulkVisitorCardForm.get('type').touched &&
                bulkVisitorCardForm.get('type').errors['required']
              "
              class="help-block has-error validationMessage"
              >Required
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <label for="bulkCardQty" class="col-md-12 control-label labelCommon">
            Quantity
          </label>
          <div class="form-group col-md-12">
            <input
              class="form-control input-sm"
              style="width: 100%"
              type="text"
              id="bulkCardQty"
              formControlName="quantity"
              maxlength="4"
            />
            <span
              *ngIf="
                !bulkVisitorCardForm.get('quantity').valid &&
                bulkVisitorCardForm.get('quantity').touched &&
                bulkVisitorCardForm.get('quantity').errors['required']
              "
              class="help-block has-error validationMessage"
            >
              Required
            </span>
            <span
              *ngIf="
                !bulkVisitorCardForm.get('quantity').valid &&
                bulkVisitorCardForm.get('quantity').touched &&
                bulkVisitorCardForm.get('quantity').errors['quantityBelowOne']
              "
              class="help-block has-error validationMessage"
            >
              Quantity should be greater than zero
            </span>
            <span
              *ngIf="
                !bulkVisitorCardForm.get('quantity').valid &&
                bulkVisitorCardForm.get('quantity').touched &&
                bulkVisitorCardForm.get('quantity').errors['quantityNonNumeric']
              "
              class="help-block has-error validationMessage"
            >
              Quantity should be a number
            </span>
          </div>
        </div>
        <div class="col-md-4" style="display: flex; align-items: center">
          <label
            class="col-md-12 control-label labelCommon align-content-between"
          >
            When 10 or less cards are ordered they will be shipped individually
            by USPS.
          </label>
        </div>
      </div>
    </form>
    <table class="table" *ngIf="bulkCardOrders">
      <tbody style="background-color: #ffffff">
        <tr *ngIf="bulkCardOrders.length == 0">
          <td align="center" colspan="7" style="height: 150px">
            No bulk card orders found.
          </td>
        </tr>
        <tr
          *ngFor="
            let bulkCardOrder of bulkCardOrders
              | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize
          "
        >
          <td class="text-left">
            <span class="labelCommon">Order Date</span><br />
            <span class="transactionHistText">{{
              bulkCardOrder.dateCreatedFormatted
            }}</span>
          </td>
          <!-- pattern "MM/dd/yyyy" -->
          <td class="text-left">
            <span class="labelCommon">Type</span><br />
            <span class="transactionHistText">{{ bulkCardOrder.type }}</span>
          </td>
          <td class="text-left">
            <span class="labelCommon">Quantity</span><br />
            <span class="transactionHistText">{{
              bulkCardOrder.orderCount
            }}</span>
          </td>
          <td class="text-left">
            <span class="labelCommon">Available</span><br />
            <span class="transactionHistText" *ngIf="bulkCardOrder.type !== 'Visitor'">{{
              bulkCardOrder.available
            }}</span>
            <span class="transactionHistText" *ngIf="bulkCardOrder.type == 'Visitor'">N/A</span>
          </td>
          <td class="text-left">
            <span class="labelCommon">Expected Delivery Date </span><br />
            <span class="transactionHistText">{{
              bulkCardOrder.expectedDeliverDate | date : "mediumDate"
            }}</span>
          </td>
          <td class="text-left">
            <div class="col-md-8">
              <span class="labelCommon">Request Status</span><br />
              <ng-container *ngIf="bulkCardOrder.descr != null">
                <span [class]="setColumnStatus(bulkCardOrder.columnValue)"
                  >{{ bulkCardOrder.descr }}
                </span>
                <div
                  class="col-md-1 float-right"
                  style="padding-top: 10px; top: -20px"
                  *ngIf="
                    'N' == bulkCardOrder.columnValue ||
                    'W' == bulkCardOrder.columnValue
                  "
                >
                  <div class="linkGreyAndRed">
                    <a
                      (click)="
                        cancelOrders(
                          bulkCardOrder.dateCreatedFormatted,
                          bulkCardOrder.type,
                          bulkCardOrder.pinMailerFlag,
                          bulkCardOrder.batchUUID
                        )
                      "
                      *ngIf="hasEntitlement('SHIPS_BULKCARDS_ORDERS_UPDATE')"
                    >
                      <i class="fa fa-trash-o"></i>
                    </a>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="bulkCardOrder.descr == null">
                <span class="transactionHistText">{{
                    'N/A'
                  }}</span>
              </ng-container>
            </div>
          </td>
          <td class="text-left">
            <div class="col-md-8">
              <span class="labelCommon">Order Status</span><br/>
              <ng-container *ngIf="bulkCardOrder.orderStatus != null">
                <span [class]="setOrderStatus(bulkCardOrder.orderStatus)"
                >{{ bulkCardOrder.orderStatus }}
                </span>
              </ng-container>
              <ng-container *ngIf="bulkCardOrder.orderStatus == null">
                <span class="transactionHistText">{{
                    'N/A'
                  }}</span>
              </ng-container>
            </div>
          </td>
          <td class="text-left">
            <span class="labelCommon">Tracking Number </span><br />
            <ng-container *ngIf="bulkCardOrder.trackingNumber != null" >
              <a [href] = "'https://www.fedex.com/fedextrack/?action=track&tracknumbers=' + bulkCardOrder.trackingNumber" target="_blank" rel="noopener noreferrer" >
              <span class="transactionHistText" style="color: #0000EE;text-decoration: underline;">{{
                '#' + bulkCardOrder.trackingNumber
                }}</span>
              </a>
            </ng-container>
            <ng-container *ngIf="bulkCardOrder.trackingNumber == null">
              <span class="transactionHistText" >{{
                'N/A'
                }}</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>

    <ngb-pagination
      [(page)]="page"
      [pageSize]="pageSize"
      [collectionSize]="bulkCardOrders?.length"
    >
    </ngb-pagination>
  </div>
</div>
